<script setup>
// core
import {useStore} from "vuex";
import {useRouter} from "vue-router";

// components
import IntegrationSelect from "@/components/Recurring/IntegrationSelect.vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        default: ''
    },
    buttonText: {
        type: String,
        required: true
    },
    // INTEGRATION_DATA filter key, e.g. viber_voip / tiktok
    filter: {
        type: String,
        required: true
    },
    routeName: {
        type: String,
        required: true
    }
})

const store = useStore()
const router = useRouter()

const onConfirm = async () => {
    store.commit('closeDialog')
    await router.push({name: props.routeName})
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper">
        <p class="wrapper__title">{{ title }}</p>
        <p v-if="subtitle" class="wrapper__subtitle">{{ subtitle }}</p>

        <div class="wrapper__content">
            <IntegrationSelect
                :options="{title: false}"
                :filter="filter"
                readonly
            />
        </div>

        <div class="wrapper__footer">
            <ButtonLoading class="ec_button" @click="onConfirm">
                {{ buttonText }}
            </ButtonLoading>
        </div>
    </div>
</template>

<style scoped lang="scss">
// same skin as AddNumberTelegramDialog
.wrapper {
    font-family: 'Gilroy', sans-serif;
    box-sizing: border-box;
    padding: 20px 28px 42px;
    max-width: 750px;
    width: 100%;
    border-radius: 7px;
    background-color: #ffffff;

    display: flex;
    flex-direction: column;
    gap: 8px;

    text-align: center;

    &__title {
        margin: 0;
        padding: 0;
        font-family: 'Gilroy', sans-serif;
        font-size: 20px;
        font-weight: 500;
        text-transform: uppercase;
        color: var(--text-color);
    }

    // .integration-select .title
    &__subtitle {
        margin: 0;
        padding: 0;
        font-family: 'Gilroy', sans-serif;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        color: var(--text-color);
    }

    &__content {
        margin-top: 12px;
    }

    &__footer {
        margin-top: 16px;
        display: flex;
        justify-content: center;
    }
}

@media screen and (max-width: 640px) {
    .wrapper {
        max-width: 100%;
        padding: 20px 14px 28px;
    }
}
</style>
